import { State } from "./State";
export class User {
    constructor(id, accountId, creationDate, lastLoginDate, lastActivityDate, enabled, typeId, name, email) {
        this.id = id;
        this.accountId = accountId;
        this.creationDate = creationDate;
        this.lastLoginDate = lastLoginDate;
        this.lastActivityDate = lastActivityDate;
        this.enabled = new State(enabled);
        this.typeId = new State(typeId);
        this.name = new State(name);
        this.email = new State(email);
    }
    clone() {
        return new User(this.id, this.accountId, this.creationDate, this.lastLoginDate, this.lastActivityDate, this.enabled.value, this.typeId.value, this.name.value, this.email.value);
    }
    refresh(fresh) {
        this.enabled.set(fresh.enabled.value);
        this.typeId.set(fresh.typeId.value);
        this.name.set(fresh.name.value);
        this.email.set(fresh.email.value);
    }
    toJSON() {
        return {
            id: this.id,
            accountId: this.accountId,
            creationDate: this.creationDate,
            lastLoginDate: this.lastLoginDate,
            lastActivityDate: this.lastActivityDate,
            enabled: this.enabled.value,
            typeId: this.typeId.value,
            name: this.name.value,
            email: this.email.value,
        };
    }
}
